
export default {
  loginBegin(state) {
    state.login = true;
  },
  loginSuccess(state, data) {
    state.loading = false;
    state.login = data;
  },

  loginErr(state, err) {
    state.loading = false;
    state.error = err;
  },

  logoutBegin(state) {
    state.currentUser = [];
    state.login = false;
    state.loading = true;
  },

  logoutSuccess(state, data) {
    state.loading = false;
    state.login = data;
    localStorage.removeItem("currentUser");
    localStorage.removeItem('access_token');

  },
  SET_CURRENT_USER(state,data){
    state.currentUserData = { ...data };
  },
  UPDATE_USERNAME(state,data){
    state.currentUserData.username = data;
  },

  removeLogged(state,data){
    state.login = data;
  },

  logoutErr(state, err) {
    state.loading = false;
    state.error = err;
  },
  loginData(state, data) {
    state.currentUser = data.user;
    // state.auth.login = true;
  },

  responseErr(state, err) {
    state.resErr = err;
  },
};
